import { Vector2i } from "js-vextensions";
import { AddSchema } from "mobx-firelink";
import { Pre, RowLR, Spinner, TextInput } from "react-vcomponents";
import { BaseComponent } from "react-vextensions";
import { UpdateMapObject } from "Server/Commands/UpdateMapObject";
import { CompUI_splitAt, CompUI_width } from "UI/Write/MapUI/Panels/ObjectPanel";
import { CompUIWrapper } from "UI/Write/MapUI/Panels/ObjectPanel/General";
export class LabelComp {
    constructor(initialData) {
        this.Extend(initialData);
    }
}
AddSchema("LabelComp", ["Vector2i"], () => ({
    properties: {
        text: { type: "string" },
        offset: { $ref: "Vector2i" },
    },
}));
export class LabelCompUI extends BaseComponent {
    render() {
        let { obj } = this.props;
        return (React.createElement(CompUIWrapper, { obj: obj, compProp: "label" },
            React.createElement(RowLR, { mt: 5, splitAt: CompUI_splitAt, style: { CompUI_width } },
                React.createElement(Pre, null, "Text: "),
                React.createElement(TextInput, { required: true, delayChangeTillDefocus: true, style: { width: "100%" }, value: obj.label.text, onChange: val => {
                        let updates = { label: obj.label.Extended({ text: val }) };
                        new UpdateMapObject({ id: obj._key, updates }).Run();
                    } })),
            React.createElement(RowLR, { mt: 5, splitAt: CompUI_splitAt, style: { CompUI_width } },
                React.createElement(Pre, null, "Offset-X: "),
                React.createElement(Spinner, { step: .01, style: { minWidth: 0 }, value: obj.label.offset.x, onChange: val => {
                        let updates = { label: obj.label.Extended({ offset: obj.label.offset.As(Vector2i).NewX(val) }) };
                        new UpdateMapObject({ id: obj._key, updates }).Run();
                    } })),
            React.createElement(RowLR, { mt: 5, splitAt: CompUI_splitAt, style: { CompUI_width } },
                React.createElement(Pre, null, "Offset-Y: "),
                React.createElement(Spinner, { step: .01, style: { minWidth: 0 }, value: obj.label.offset.y, onChange: val => {
                        let updates = { label: obj.label.Extended({ offset: obj.label.offset.As(Vector2i).NewY(val) }) };
                        new UpdateMapObject({ id: obj._key, updates }).Run();
                    } }))));
    }
}
